import React from 'react';
import AppleStoreLogo from 'assets/applestore.webp';
import GooglePlayLogo from 'assets/playstore.webp';
import BannerVideo from 'assets/144590-785095798_medium.mp4';

export const Banner = () => {
  return (
    <div>
      <div className="w-full h-[calc(100vh-10rem)] relative flex items-center justify-center text-white rounded-3xl">
        {/* Background Video */}
        <video
          className="absolute top-0 left-0 w-full h-full object-cover rounded-3xl"
          autoPlay
          loop
          muted
        >
          <source src={BannerVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="absolute inset-0 bg-black bg-opacity-20 rounded-3xl"></div>

        {/* Content Section */}
        <div className="relative z-1 w-full max-w-6xl px-6 md:px-12 text-center md:text-start">
          <h1 className="text-4xl md:text-6xl font-bold leading-snug">
            Fast, <span className="text-[#26C4FF]">Secure</span>, and limitless Money Transfers
            Anytime, <span className="text-[#26C4FF]">Anywhere</span>.
          </h1>
          <p className="mt-6 text-lg md:text-xl max-w-md">
            Seamless, secure, and lightning-fast. Wire24 lets you send and receive money across the
            world—instantly, anytime, anywhere. No delays, no hidden fees, just effortless transfers
            at unbeatable rates!
          </p>

          {/* App Store Links */}
          <div className="mt-8 flex flex-col sm:flex-row items-center sm:items-start space-y-4 sm:space-y-0 sm:space-x-2">
            <a href="#">
              <img
                src={AppleStoreLogo}
                alt="Download on the Apple Store"
                className="h-12 md:h-16"
              />
            </a>
            <a href="#">
              <img src={GooglePlayLogo} alt="Get it on Google Play" className="h-12 md:h-16" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
